import dayjs from 'dayjs';

type DateFormat = 'YYYY-MM-DD' | 'YYYY-MM-DD HH:mm' | (string & {});

/**
 * Unix 秒时间戳格式化
 * @param unixSeconds Unix 秒时间戳，falsy 时返回空字符串
 * @param format 格式化模板，默认 YYYY-MM-DD
 */
export const formatUnixDate = (unixSeconds: number, format: DateFormat = 'YYYY-MM-DD'): string => {
    if (!unixSeconds) {
        return '';
    }
    return dayjs.unix(unixSeconds).format(format);
};
